export const PAGINATION_ORDERS_LIMIT = 20;
